<div class="wistia-video">
    <div class="wistia-video__filter">
        <div class="wistia-video__filter-wrapper">
            <p class="wistia-video__filter-text">Filter by:</p>
            <a
                class="wistia-video__filter-button"
                [class.active]="activeFilter() === 'all'"
                tabindex="0"
                (click)="filterBy('all')"
                (keydown.enter)="filterBy('all')"
                (keydown.space)="filterBy('all'); $event.preventDefault()"
                [innerText]="'All'"></a>
            @for (tag of pillars$ | async; track tag) {
                <a
                    class="wistia-video__filter-button"
                    [class.active]="activeFilter() === tag.name"
                    tabindex="0"
                    (click)="filterBy(tag.name)"
                    (keydown.enter)="filterBy(tag.name)"
                    (keydown.space)="filterBy(tag.name); $event.preventDefault()"
                    [innerText]="tag.name"></a>
            }
        </div>
        <p
            class="wistia-video__filter-text"
            [innerText]="'Showing ' + displayedItems().length + ' of ' + filteredItems().length + ' videos'"></p>
    </div>

    @if (displayedItems().length > 0) {
        @for (item of displayedItems(); track item) {
            @if (item.data.openInModal) {
                <!-- Wistia Popover embed code. A thumbnail by Wistia gets used and a click opens video in modal -->
                <div class="wistia-video__inner">
                    <div class="wistia_responsive_padding" style="padding: 56.25% 0 0 0; position: relative">
                        <div
                            class="wistia_responsive_wrapper"
                            style="height: 100%; left: 0; position: absolute; top: 0; width: 100%">
                            <span
                                [class]="
                                    'wistia_embed wistia_async_' +
                                    item.data.id +
                                    ' popover=true videoFoam=true captionsButton=true'
                                "
                                style="display: inline-block; height: 100%; position: relative; width: 100%"
                                >&nbsp;</span
                            >
                        </div>
                    </div>
                    <div class="wistia-video__content">
                        @if (item.data.tag) {
                            <p class="wistia-video__tag" [innerText]="item.data.tag"></p>
                        }
                        @if (item.data.title) {
                            <h3 class="wistia-video__title" [innerText]="item.data.title"></h3>
                        }
                        @if (item.data.description) {
                            <p class="wistia-video__description" [innerHTML]="item.data.description"></p>
                        }
                    </div>
                </div>
            } @else {
                <!-- Standard embed for inline video -->
                <div class="wistia-video__inner">
                    <div [class]="'wistia_embed wistia_async_' + item.data.id + ' captionsButton=true'"></div>
                    <div class="wistia-video__content">
                        @if (item.data.tag) {
                            <p class="wistia-video__tag" [innerText]="item.data.tag"></p>
                        }
                        @if (item.data.title) {
                            <h3 class="wistia-video__title" [innerText]="item.data.title"></h3>
                        }
                        @if (item.data.description) {
                            <p class="wistia-video__description" [innerHTML]="item.data.description"></p>
                        }
                    </div>
                </div>
            }
        }
    }
    @if (limit() < filteredItems().length) {
        <div class="wistia-video__load-more-wrapper">
            <button class="btn btn-primary wistia-video__load-more" (click)="showAll()">Load more videos</button>
        </div>
    }
</div>
